module.exports = __webpack_public_path__ + "static/media/roc.4fac9aa0.jpg";